if (!customElements.get("upsell-slider")) {
  class UpsellSlider extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', event => {
        const nextButton = event.target.closest('[data-upsell-slider-next]');
        const prevButton = event.target.closest('[data-upsell-slider-prev]');
        if (!nextButton && !prevButton) return;
    
        const scrollableArea = this.querySelector('.upsell-slider__upsell-list');
        if (!scrollableArea) return;
        let scrollLeft = scrollableArea.scrollLeft;
    
        if (nextButton) {
          const nextSlide = Array.from(this.querySelectorAll('.upsell-slider__upsell-list .upsell-item')).find(
            (element) => element.offsetLeft > scrollLeft + 1
          );
          if (nextSlide) {
            scrollLeft = nextSlide.offsetLeft;
          }
        } else {
    
          const prevSlide = Array.from(this.querySelectorAll('.upsell-slider__upsell-list .upsell-item')).findLast(
            (element) => element.offsetLeft < scrollLeft - 1
          );
          if (prevSlide) {
            scrollLeft = prevSlide.offsetLeft;
          }
        }
    
        scrollableArea.scrollTo({
          top: 0,
          left: scrollLeft,
          behavior: "smooth",
        })
      });
    }
  }

  customElements.define("upsell-slider", UpsellSlider);
}
